<nz-spin [nzSpinning]="isSpinning">
  <div class="sales-portal-container">
    <div class="turnover-detail">
      <div class="detail-setting-header">
        <nz-breadcrumb>
          <nz-breadcrumb-item (click)="navigate('/sales-portal/turnover')" style="cursor: pointer">Turnover
          </nz-breadcrumb-item>
          <nz-breadcrumb-item>Dealer Settings</nz-breadcrumb-item>
        </nz-breadcrumb>
        <div class="title">Dealer Settings</div>
        <div class="key-value-box">
          <div class="key-value-item">
            <div class="key">Dealer Code</div>
            <div class="value ml20">{{ detailInfo.dealerCode }}</div>
          </div>
          <div class="key-value-item">
            <div class="key">Dealer Name</div>
            <div class="value ml20">{{ detailInfo.dealerName }}</div>
          </div>
          <div class="key-value-item">
            <div class="key">Target Year</div>
            <div class="value ml20">{{ detailInfo.targetYear }}</div>
          </div>
          <div class="divider"></div>
          <div class="key-value-item">
            <div class="value">Target Turnover</div>
            <div class="key ml20 flex-center">
              <div style="width: 120px">
                <sales-portal-input-number
                  [(ngModel)]="detailInfo.targetProcurement"
                  [disabled]="nextStepStatus!==''"
                ></sales-portal-input-number>
              </div>
              <span class="unit">(CNY)</span>
              <svg-icon
                *ngIf="nextStepStatus ===''"
                iconName="sales-portal-edit.svg"
                style="margin-left: 5px;"
                (click)="editTargetProcurement = true" [size]="14"></svg-icon>
            </div>
          </div>
          <div class="key-value-item">
            <div class="value">Remaining</div>
            <div class="key ml20">
              <span
                *ngIf="!nextStepStatus;else elseRemaining">{{ salesPortalService.formatThousands(remaining, true) }}</span>
              <ng-template #elseRemaining>
                <span>{{ salesPortalService.formatThousands(nextRemaining, true) }}</span>
              </ng-template>
              <span class="unit">(CNY)</span>
            </div>
          </div>
        </div>
      </div>


      <div class="title-section" style="margin-top: 40px">
        <div class="title">
          <span *ngIf="detailInfo.classificationMethod === 'PRODUCT_GROUP'">Product Group Splitting Amounts</span>
          <span *ngIf="detailInfo.classificationMethod === 'CBF'">CBF Splitting Amounts</span>
          <span *ngIf="detailInfo.classificationMethod === 'PACKAGE'">Pack Splitting Amounts</span>
        </div>
        <button nz-button nzType="primary" (click)="handleEdit()" *ngIf="!editStatus">Edit</button>
      </div>

      <!-- View Mode-->
      <div *ngIf="!editStatus" class="filter-table-section" style="margin-top: 20px">
        <product-group-table
          *ngFor="let data of detailInfo.targetClassificationList"
          [classificationMethod]="detailInfo.classificationMethod"
          [year]="detailInfo.targetYear"
          [timeMode]="detailInfo.targetSplitMethod"
          [splittingMethod]="splittingMethod"
          [tableData]="data.targetConfigurationList"
          [targetAmount]="data.targetAmount"
          [productGroup]="data.productGroup"
          [cbf]="data.cbf"
          [cbfDesc]="data.description"
          [disableEdit]="true"
        >
        </product-group-table>
      </div>
      <div *ngIf="editStatus">
        <!-- Filter -->
        <div style="display: flex;margin-top: 10px">
          <nz-form-item class="search-form-item">
            <nz-form-label>Splitting Method</nz-form-label>
            <nz-form-control class="line">
              <nz-select style="width: 200px"
                         [nzSuffixIcon]="suffixSearch"
                         [(ngModel)]="splittingMethod"
                         (ngModelChange)="handleSplittingMethodChange()"
              >
                <nz-option nzValue="manualSplitting" nzLabel="Manual Splitting"></nz-option>
                <nz-option nzValue="automaticallySplitting" nzLabel="Automatically Splitting"></nz-option>
              </nz-select>
              <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item class="search-form-item" style="margin-left: 20px" *ngIf="editStatus && nextStepStatus !==''">
            <nz-form-label>Time</nz-form-label>
            <nz-form-control class="line">
              <nz-select style="width: 200px" [nzSuffixIcon]="suffixSearch"
                         [(ngModel)]="time"
                         (ngModelChange)="handleTimeChange()">
                <nz-option nzValue="BY_YEAR" nzLabel="Year"></nz-option>
                <nz-option nzValue="BY_QUARTER" nzLabel="Quarter"></nz-option>
                <nz-option nzValue="BY_MONTH" nzLabel="Month"></nz-option>
              </nz-select>
              <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
        <!-- Edit Mode Product Group-->
        <div *ngIf="editStatus && !nextStepStatus">
          <two-column-table
            [classificationMethod]="detailInfo.classificationMethod"
            [splittingMethod]="splittingMethod"
            [dataList]="detailInfo.targetClassificationList"
          >
          </two-column-table>
          <div class="button-section">
            <button nz-button nzType="default" (click)="handleNextStepCancel()">Cancel</button>
            <button nz-button nzType="primary" (click)="handleNextStep()" style="margin-left: 10px">Next Step</button>
          </div>
        </div>
      </div>

      <!--Next Step Quarter-->
      <div *ngIf="nextStepStatus === 'BY_QUARTER'">
        <product-group-table
          *ngFor="let data of detailInfo.targetClassificationList"
          [classificationMethod]="detailInfo.classificationMethod"
          [timeMode]="'BY_QUARTER'"
          [splittingMethod]="splittingMethod"
          [tableData]="data.targetConfigurationList"
          [targetAmount]="data.targetAmount"
          [productGroup]="data.productGroup"
          [cbf]="data.cbf"
          [cbfDesc]="data.description"
          [detailInfo]="detailInfo"
        >
        </product-group-table>
      </div>

      <div *ngIf="nextStepStatus === 'BY_MONTH'">
        <product-group-table
          *ngFor="let data of detailInfo.targetClassificationList"
          [classificationMethod]="detailInfo.classificationMethod"
          [timeMode]="'BY_MONTH'"
          [splittingMethod]="splittingMethod"
          [tableData]="data.targetConfigurationList"
          [targetAmount]="data.targetAmount"
          [productGroup]="data.productGroup"
          [cbf]="data.cbf"
          [cbfDesc]="data.description"
          [detailInfo]="detailInfo"
        >
        </product-group-table>
      </div>

      <div *ngIf="nextStepStatus === 'BY_YEAR'">
        <product-group-table
          *ngFor="let data of detailInfo.targetClassificationList"
          [classificationMethod]="detailInfo.classificationMethod"
          [year]="detailInfo.targetYear"
          [timeMode]="'BY_YEAR'"
          [splittingMethod]="splittingMethod"
          [tableData]="data.targetConfigurationList"
          [targetAmount]="data.targetAmount"
          [productGroup]="data.productGroup"
          [cbf]="data.cbf"
          [cbfDesc]="data.description"
          [detailInfo]="detailInfo"
        >
        </product-group-table>
      </div>


      <!--Last Step & Save-->
      <div class="last-step-and-save" *ngIf="nextStepStatus">
        <button nz-button nzType="default" (click)="handleLastStep()"
                *ngIf="detailInfo.classificationMethod !== 'PACKAGE'">
          Last Step
        </button>
        <button nz-button nzType="default" (click)="handleCancel()"
                *ngIf="detailInfo.classificationMethod === 'PACKAGE'">
          Cancel
        </button>
        <button nz-button nzType="primary" (click)="handleSave()" style="margin-left: 10px">Save</button>
      </div>
    </div>

  </div>
</nz-spin>



